import crudHandlers from './_crud'

const initialState = {
	entities: {},
	is_fetching: false,
	active: undefined,
	transferFuelSupplyTemplateHasChanges: false,
}

export default (state = initialState, action) => {
	const { type } = action
	switch (type) {
		case 'SET_TRANSFER_FUEL_SUPPLY_TEMPLATE_HAS_CHANGES':
			return {
				...state,
				transferFuelSupplyTemplateHasChanges: action.payload
			}

		default:
			state = crudHandlers(state, action, 'super_admin')

			return state
	}
}